var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13895 0 0 3.13895 0 7C0 10.8611 3.13895 14 7 14C10.8611 14 14 10.8611 14 7C14 3.13895 10.8611 0 7 0ZM7 12.7179C3.84632 12.7179 1.28211 10.1537 1.28211 7C1.28211 3.84632 3.84632 1.28211 7 1.28211C10.1537 1.28211 12.7179 3.84632 12.7179 7C12.7179 10.1537 10.1537 12.7179 7 12.7179Z",
    fill: "#8D9091"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53287 5.36408C8.99679 5.36408 9.37287 4.988 9.37287 4.52408C9.37287 4.06016 8.99679 3.68408 8.53287 3.68408C8.06895 3.68408 7.69287 4.06016 7.69287 4.52408C7.69287 4.988 8.06895 5.36408 8.53287 5.36408Z",
    fill: "#8D9091"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28439 6.67565C9.09281 6.41039 8.69491 6.41039 8.50333 6.67565L8.17912 7.11775C8.12017 7.20618 7.97281 7.20618 7.91386 7.11775L6.5286 5.18723C6.33702 4.92197 5.93912 4.92197 5.74754 5.18723L3.38965 8.51776C3.1686 8.82723 3.38965 9.26933 3.77281 9.26933H10.2128C10.596 9.26933 10.8318 8.82723 10.596 8.51776L9.28439 6.67565Z",
    fill: "#8D9091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.4a28c5e495da4f6df429095f840e92a6.svg";
export { ForwardRef as ReactComponent };